const actions = {
  GET_VENDOR: "GET_VENDOR",
  GET_VENDOR_SUCCESS: "GET_VENDOR_SUCCESS",
  GET_VENDOR_FAILED: "GET_VENDOR_FAILED",

  RESET_MESSAGE: 'RESET_MESSAGE',

  GET_ACODE: "GET_ACODE",
  GET_ACODE_SUCCESS: "GET_ACODE_SUCCESS",
  GET_ACODE_FAILED: "GET_ACODE_FAILED",

  GET_PLAN: "GET_PLAN",
  GET_PLAN_SUCCESS: "GET_PLAN_SUCCESS",
  GET_PLAN_FAILED: "GET_PLAN_FAILED",

  GET_BILLING_CODE: "GET_BILLING_CODE",
  GET_BILLING_CODE_SUCCESS: "GET_BILLING_CODE_SUCCESS",
  GET_BILLING_CODE_FAILED: "GET_BILLING_CODE_FAILED",



  getVendor: () => ({
    type: actions.GET_VENDOR,
  }),
  getVendorSuccess: (data) => ({
    type: actions.GET_VENDOR_SUCCESS,
    data,
  }),
  getVendorError: (error) => ({
    type: actions.GET_VENDOR_FAILED,
    error,
  }),

  getACode: () => ({
    type: actions.GET_ACODE,
  }),
  getACodeSuccess: (data) => ({
    type: actions.GET_ACODE_SUCCESS,
    data,
  }),
  getACodeError: (error) => ({
    type: actions.GET_ACODE_FAILED,
    error,
  }),

  getPlan: (data) => ({
    type: actions.GET_PLAN,
    payload: { data },
  }),
  getPlanSuccess: (result) => ({
    type: actions.GET_PLAN_SUCCESS,
    result
  }),
  getPlanError: (error) => ({
    type: actions.GET_PLAN_FAILED,
    error
  }),

  getBillingCode: (data) => ({
    type: actions.GET_BILLING_CODE,
    payload: { data },
  }),
  getBillingCodeSuccess: (result) => ({
    type: actions.GET_BILLING_CODE_SUCCESS,
    result
  }),
  getBillingCodeError: (error) => ({
    type: actions.GET_BILLING_CODE_FAILED,
    error
  }),

  resetMessage: () => ({
    type: actions.RESET_MESSAGE,
  }),
};
export default actions;
